import { render, staticRenderFns } from "./BoostPlanManagementAfterCreate.vue?vue&type=template&id=d97a5228"
import script from "./BoostPlanManagementAfterCreate.vue?vue&type=script&lang=js"
export * from "./BoostPlanManagementAfterCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports